import { render, staticRenderFns } from "./ConsignatariasIndex.vue?vue&type=template&id=f67cd8e6&"
import script from "./ConsignatariasIndex.vue?vue&type=script&lang=js&"
export * from "./ConsignatariasIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports